import { Button, Card, CardContent, Dialog, DialogContent, Grid } from '@mui/material'
import { CardTable, SORT } from 'common/components/datatable/Table'
import { CardTitle } from 'common/components/card/Card'
import ConfirmModal from 'common/components/modal/ConfirmModal'
import Checkbox from 'common/components/form/Checkbox'
import { BasicDialogAction, BasicDialogTitle } from 'common/components/modal/DialogComponents'
import Input from 'common/components/form/Input'
import { isNil, orderBy, toLower, uniq } from 'lodash'
import React, { useEffect, useMemo, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import useActions from 'common/hooks/useActions'
import useBoolean from 'common/hooks/useBoolean'
import useTitles from 'common/hooks/useTitles'
import PropTypes from 'prop-types'
import { NEW } from 'common/components/action/ActionConstant'
import { darkBlue, greyBlue } from 'app/theme'
import Select from 'common/components/form/Select'
import { INSTANCE_TYPE } from 'supervision/instance/constants/InstanceConstants'
import { InstanceParameterDialog } from '../instance/components/InstanceDescriptionApp'
import { hasPermission } from 'common/utils/HabilitationUtil'
import { useNavigate } from 'react-router'
import { createInstance, fetchInstances, InstancesActions, selectInstances } from 'supervision/instances/InstancesSlice'

const PopinInstance = ({
    isOpen = false,
    close = () => {},
    reload = () => {},
}) => {
    const dispatch = useDispatch()

    const {
        value: isLoading,
        setTrue: loading,
        setFalse: notLoading,
    } = useBoolean(false)

    const {
        value: isChainCreate,
        toggle: toggleChainCreate,
    } = useBoolean(false)

    const {
        value: isPopinOpen,
        setTrue: onOpenPopin,
        setFalse: onClosePopin,
    } = useBoolean(false)
    const {
        value: isConfirmOpen,
        setTrue: onOpenConfirm,
        setFalse: onCloseConfirm,
    } = useBoolean(false)

    const [selectedParameter, setSelectedParameter] = useState()

    const [name, setName] = useState()
    const [server, setServer] = useState()
    const [instanceType, setInstanceType] = useState()
    const [url, setUrl] = useState()
    const [parameters, setParameters] = useState([])

    useEffect(() => {
        if (isOpen) {
            setName()
            setServer()
            setInstanceType()
            setUrl()
            setParameters([])
        }
    }, [isOpen])

    const resetAllField = () => {
        setName()
        setServer()
        setInstanceType()
        setUrl()
        setParameters([])
    }

    const validate = () => {
        loading()
        dispatch(createInstance({ id: -1, name, server, instanceType, url, parameters }))
            .then(res => {
                if (!res) return
                reload()
                if (!isChainCreate) {
                    close()
                } else {
                    resetAllField()
                }
            })
            .finally(notLoading)
    }

    const onDeleteParameter = row => {
        setSelectedParameter(row.parameter)
        onOpenConfirm()
    }

    const onEditParameter = row => {
        setSelectedParameter(row.parameter)
        onOpenPopin()
    }

    const parameter = parameters.find(p => p.parameter === selectedParameter)

    return (
        <Dialog
            open={isOpen}
            maxWidth={'xl'}
        >
            <BasicDialogTitle onClose={close}>
                Instance
            </BasicDialogTitle>
            <DialogContent style={{ overflowX: 'hidden' }}>
                <Grid container spacing={1}>
                    <Grid size={12}>
                        <Card>
                            <CardContent>
                                <Grid container columnSpacing={2} rowSpacing={1} alignItems='center' style={{ paddingTop: '5px' }}>
                                    <Grid size={6}>
                                        <Input
                                            label={'Nom'}
                                            value={name}
                                            onChange={setName}
                                        />
                                    </Grid>
                                    <Grid size={6}>
                                        <Input
                                            label={'Serveur'}
                                            value={server}
                                            onChange={setServer}
                                            type='float'
                                        />
                                    </Grid>
                                    <Grid size={6}>
                                        <Select
                                            label={'Type d\'instance'}
                                            items={INSTANCE_TYPE}
                                            value={instanceType}
                                            onChange={setInstanceType}
                                            undefinedValue
                                        />
                                    </Grid>
                                    <Grid size={6}>
                                        <Input
                                            label={'Url'}
                                            value={url}
                                            onChange={setUrl}
                                        />
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid size={12}>
                        <CardTable
                            title='Paramètrage'

                            rows={parameters}
                            headers={[{ key: 'parameter', value: 'Paramètre' }, { key: 'value', value: 'Valeur' }]}

                            actions={[{
                                icon: 'add',
                                onClick: onOpenPopin,
                                tooltip: 'Nouveau paramètre',
                            }]}
                            lineActions={[
                                { icon: 'delete', onClick: onDeleteParameter },
                                { icon: 'edit', onClick: onEditParameter },
                            ]}
                        />
                        <InstanceParameterDialog
                            isOpen={isPopinOpen}
                            parameter={parameter}
                            onClose={() => {
                                setSelectedParameter()
                                onClosePopin()
                            }}
                            onValidate={newParam => {
                                const formattedParam = { ...newParam, instanceId: -1 }
                                setParameters(params => {
                                    if (isNil(selectedParameter)) return [...params, formattedParam]
                                    return params.map(p => p.parameter === selectedParameter ? formattedParam : p)
                                })
                                setSelectedParameter()
                                onClosePopin()
                            }}
                        />
                        <ConfirmModal
                            isOpen={isConfirmOpen}
                            title='Êtes-vous sûr de vouloir supprimer ce paramètrage ?'
                            onValidate={() => {
                                setParameters(params => params.filter(p => p.parameter !== selectedParameter))
                                onCloseConfirm()
                            }}
                            onClose={onCloseConfirm}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <BasicDialogAction
                buttonLabel={'Créer'}
                onValidate={validate}
                isLoading={isLoading}
                isDisabled={isNil(name) || isNil(server) || isNil(instanceType) || isNil(url)}
            >
                <Checkbox
                    label='Saisir une autre instance'
                    checked={isChainCreate}
                    onToggle={toggleChainCreate}
                    labelStyle={{ color: '#555', fontWeight: 'normal' }}
                />
            </BasicDialogAction>
        </Dialog>
    )
}

PopinInstance.propTypes = {
    isOpen: PropTypes.bool,
    close: PropTypes.func,
    reload: PropTypes.func,
}

const FilterInstances = ({ filters = {}, setFilters = () => {}, typeItems = [], serverItems = [] }) => {
    const { search = '', types = [], servers = [] } = filters
    return (
        <Card sx={{ marginBottom: 1 }}>
            <CardTitle title='Filtre' color={darkBlue} />
            <CardContent>
                <Grid container spacing={1} alignItems='center'>
                    <Grid size={3}>
                        <Input label='Rechercher' value={search} onChange={v => setFilters({ ...filters, search: v })} />
                    </Grid>
                    <Grid size={3}>
                        <Select
                            multiple
                            label={'Type d\'instance'}
                            value={types}
                            items={typeItems}
                            onChange={v => setFilters({ ...filters, types: v })}
                            undefinedValue
                        />
                    </Grid>
                    <Grid size={3}>
                        <Select
                            multiple
                            label='Serveur'
                            value={servers}
                            items={serverItems}
                            onChange={v => setFilters({ ...filters, servers: v })}
                            sortItems={false}
                            undefinedValue
                        />
                    </Grid>
                    <Grid container size='grow' justifyContent='flex-end' alignItems='center'>
                        <Button variant='outlined' onClick={() => setFilters({})}>Réinitialiser</Button>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}

FilterInstances.propTypes = {
    filters: PropTypes.object,
    setFilters: PropTypes.func,
    typeItems: PropTypes.arrayOf(PropTypes.shape({})),
    serverItems: PropTypes.arrayOf(PropTypes.shape({})),
}

const InstancesApp = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const {
        user,
        status,
    } = useSelector(store => ({
        user: store.app.user,
        status: store.supervision.instances.status,
    }), shallowEqual)
    const instances = useSelector(selectInstances, shallowEqual)

    const {
        value: isOpenPopin,
        setTrue: openPopin,
        setFalse: closePopin,
    } = useBoolean(false)

    useTitles(() => [{
        label: 'Instance',
        href: '/instance',
    }], [])

    useEffect(() => {
        dispatch(fetchInstances())
    }, [dispatch])

    const [filters, setFilters] = useState({})

    // Types présents parmi les instances (avec libellé) + serveurs distincts, pour les selects de filtre.
    const typeItems = useMemo(
        () => uniq(instances.map(i => i.instanceType))
            .map(t => ({ value: t, label: INSTANCE_TYPE.find(it => it.value === t)?.label ?? 'Inconnue' })),
        [instances],
    )
    const serverItems = useMemo(
        () => orderBy(uniq(instances.map(i => i.server)), s => Number(s))
            .map(s => ({ value: s, label: String(s) })),
        [instances],
    )

    const filteredInstances = useMemo(() => {
        const { search, types, servers } = filters
        const s = toLower(search)
        const bySearch = s ? instances.filter(i => toLower(`${i.name ?? ''} ${i.url ?? ''}`).includes(s)) : instances
        const byType = types?.length ? bySearch.filter(i => types.includes(i.instanceType)) : bySearch
        return servers?.length ? byType.filter(i => servers.includes(i.server)) : byType
    }, [instances, filters])

    const formattedInstances = filteredInstances.map(instance => ({
        id: instance.id,
        name: { value: instance.name },
        server: { value: instance.server },
        instanceType: { value: INSTANCE_TYPE.find(t => t.value === instance.instanceType)?.label ?? 'Inconnue' },
        url: {
            value: instance.url,
            fontColor: greyBlue,
            onClick: instance.url ? () => window.open(instance.url, '_blank') : undefined,
        },
    }))

    useActions(() => [{
        type: NEW,
        onClick: openPopin,
        displayed: hasPermission(user, 'instances', 'create'),
    }], [])

    return (
        <div style={{ paddingBottom: '50px' }}>
            <FilterInstances filters={filters} setFilters={setFilters} typeItems={typeItems} serverItems={serverItems} />
            <CardTable
                title={'Instances'}
                color={'#161832'}

                rows={formattedInstances}
                headers={[{ key: 'name', value: 'Nom' }, { key: 'server', value: 'Serveur' }, { key: 'instanceType', value: 'Type d\'instance' }, { key: 'url', value: 'Url' }]}
                defaultSort={{ column: 'name', direction: SORT.ASC }}
                onClickRow={({ id }) => navigate(`/instance/${id}`)}

                actions={[{
                    icon: 'replay',
                    onClick: () => {
                        dispatch(InstancesActions.reset())
                        dispatch(fetchInstances())
                    },
                    tooltip: 'Recharger',
                }]}
                status={status}
            />
            <PopinInstance
                isOpen={isOpenPopin}
                close={closePopin}
                reload={() => dispatch(fetchInstances())}
            />
        </div>
    )
}

export default InstancesApp